import { SVGProps } from 'react';

const OutageHouseIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="317"
    height="308"
    viewBox="0 0 317 308"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.4351 83.0283L163.77 167.23V307.565L23.4351 223.364V83.0283Z"
      fill="#374151"
    />
    <path
      d="M163.771 151.714L220.906 89.997L293.034 85.175V225.51L163.771 307.557V151.714Z"
      fill="#1F2937"
    />
    <path
      d="M185.489 178.487L207.139 164.748V200.111L185.489 213.861V178.487Z"
      fill="#DDB96E"
    />
    <path
      d="M0.000428183 97.9927L148.789 183.532L222.189 97.7471L74.7256 8.90723L0.000428183 97.9927Z"
      fill="#4B5563"
    />
    <path
      d="M0.000564055 98.0112L148.79 183.551L148.79 189.317L0 103.825L0.000564055 98.0112Z"
      fill="#4B5563"
    />
    <path
      d="M222.204 97.7588L148.774 183.537L148.775 189.304L222.203 103.573L222.204 97.7588Z"
      fill="#4B5563"
    />
    <path
      d="M222.22 97.7599L316.198 87.8005L316.198 93.5673L222.22 103.574L222.22 97.7599Z"
      fill="#4B5563"
    />
    <path
      d="M167.15 0L316.201 87.8046L222.27 97.856L74.7129 8.9958L167.15 0Z"
      fill="#6B7280"
    />
  </svg>
);

export default OutageHouseIcon;
